export default async(to, from, next) => {
  //document.title = to.name
  if(to.path  !== '/login' && localStorage.getItem('token') == null){
    next('/login')
  }
  next()
}



// WEBPACK FOOTER //
// ./src/router/beforeEach.js